import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE: {
  isVisible: boolean;
  progressStatus: string;
} = {
  isVisible: false,
  progressStatus: ""
};

export const AiSummary = createSlice({
  name: "AiSummary",
  initialState: INIT_STATE,
  reducers: {
    setVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setProgress: (state, action) => {
      state.progressStatus = action.payload;
    }
  }
});
